import type { VoiceAction } from '../types/voice';

export function voiceActionsById(actions: VoiceAction[]): Map<string, VoiceAction> {
  return new Map(actions.map((a) => [a.id, a]));
}

export function voiceExtraRemoveCountByDependencyId(actions: VoiceAction[]): Map<string, number> {
  return actions
    .flatMap((a) => a.dependsOnActionIds ?? [])
    .reduce((m, id) => {
      m.set(id, (m.get(id) ?? 0) + 1);
      return m;
    }, new Map<string, number>());
}

export function voiceResolvedDependents(
  ids: string[] | undefined,
  byId: Map<string, VoiceAction>,
): VoiceAction[] | undefined {
  if (!ids?.length) return undefined;
  const list = ids.map((id) => byId.get(id)).filter((a): a is VoiceAction => a != null);
  return list.length ? list : undefined;
}
